import { frameworkButtonPanel } from "../../../core/components/buttonpanel/configuration/buttonpanelconfiguration"
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


frameworkButtonPanel.data = {
    "alwaysEnableButtonNameList": ["btn_setting"],
    "COREBUTTONPANEL": [],
    "COMPONENTS": [

        {
            "id": "genericUI",
            "name": "GenericUIContainer",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            child: [
                {
                    "id": "GenericUIComponent",
                    "name": "ButtonPanelGenericUI",
                    "type": "Tag",
                    "class": "",
                    "filterTypes": [],
                    "alwaysEnableButtonNameList": ["btn_help", "btn_sound", "btn_soundOff"],
                    child: [


                        {
                            "id": "stageClickContainer",
                            "name": "stageClickContainer",
                            "type": "Container",
                            "x": 0,
                            "y": 0,
                            "visible": true,
                            "filterTypes": [],
                            child: [
                                {
                                    "name": "winCelebration_Graphic",
                                    "type": "Graphic",
                                    "shape": "rectangle",
                                    "visible": true,
                                    "alpha": 0.0001,
                                    "color": "0x000000",
                                    "x": 0,
                                    "y": 300,
                                    "width": 1920,
                                    "height": 800,

                                },
                            ]
                        },

                        {
                            "id": "btn_spin_stop",
                            "name": "btn_spin_stop",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "x": 1770,
                            "y": 900,
                            "height": 142,
                            "width": 142,
                            "text": "",
                            "visible": false,
                            "buttonState": {
                                up: 'stop_up.png',
                                out: 'stop_up.png',
                                down: 'stop_up.png',
                                disable: 'stop_disable.png',
                                enable: 'stop_up.png',
                                hover: 'stop_over.png'
                            },
                            "hitareaVisible": true,

                        },


                        {
                            "id": "Button_M14",
                            "name": "btn_spinStoke",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1604,
                            "y": 357,
                            "width": 302,
                            "height": 257,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_spinstroke_up.png',
                                out: 'land_spinstroke_up.png',
                                down: 'land_spinstroke_up.png',
                                disable: 'land_spinstroke_disable.png',
                                enable: 'land_spinstroke_up.png',
                                hover: 'land_spinstroke_up.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "Button_M2",
                            "name": "btn_spin",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 0,
                            "y": 0,
                            "width": 225,
                            "height": 225,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_spin_up.png',
                                out: 'land_spin_up.png',
                                down: 'land_spin_up.png',
                                disable: 'land_spin_disable.png',
                                enable: 'land_spin_up.png',
                                hover: 'land_spin_up.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        /*     {
                                "id": "Button_M2",
                                "name": "btn_spinStop",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                "layout": true,
                                "uimode": "mobile",
                                "x": 0,
                                "y": 0,
                                "width": 142,
                                "height": 142,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'autoplay_spin_up.png',
                                    out: 'autoplay_spin_up.png',
                                    down: 'autoplay_spin_up.png',
                                    disable: 'autoplay_spin_up.png',
                                    enable: 'autoplay_spin_up.png',
                                    hover: 'autoplay_spin_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            }, */


                        {
                            "id": "Button_M10",
                            "name": "btn_autoplay",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1613,
                            "y": 466,
                            "height": 31,
                            "width": 32,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_autoplay_pressed.png',
                                out: 'land_autoplay_pressed.png',
                                down: 'land_autoplay_pressed.png',
                                disable: 'land_autoplay_pressed.png',
                                enable: 'land_autoplay_pressed.png',
                                hover: 'land_autoplay_pressed.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "Button_M14",
                            "name": "btn_autoplay_stopmobile",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "mobile",
                            "interactive": false,
                            "layout": true,
                            "x": 1708,
                            "y": 414,
                            "height": 142,
                            "width": 142,
                            "text": "",
                            "visible": false,
                            "buttonState": {
                                up: 'autoplay_spin_up.png',
                                out: 'autoplay_spin_up.png',
                                down: 'autoplay_spin_up.png',
                                disable: 'autoplay_spin_up.png',
                                enable: 'autoplay_spin_up.png',
                                hover: 'autoplay_spin_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "Button_Spin",
                            "name": "btn_spin",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": false,
                            "x": 1770,
                            "y": 900,
                            "height": 142,
                            "width": 142,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'spin_up.png',
                                out: 'spin_up.png',
                                down: 'spin_up.png',
                                disable: 'spin_disable.png',
                                enable: 'spin_up.png',
                                hover: 'spin_over.png'
                            },
                            "hitareaVisible": true,

                        },
                        {
                            "id": "historyBtnContainer",
                            "name": "historyBtnContainer",
                            "type": "Container",
                            "x": 40,
                            "y": 954,
                            "visible": false,
                            "layout": true,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "btn_history_highlighted",
                                    "name": "btn_history_highlighted",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": false,
                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'history_pressed.png',
                                        out: 'history_pressed.png',
                                        down: 'history_pressed.png',
                                        disable: 'history_pressed.png',
                                        enable: 'history_pressed.png',
                                        hover: 'history_pressed.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                                {
                                    "id": "btn_history",
                                    "name": "btn_history",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'history_up.png',
                                        out: 'history_up.png',
                                        down: 'history_up.png',
                                        disable: 'history_up.png',
                                        enable: 'history_up.png',
                                        hover: 'history_over.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                            ]
                        },
                        {
                            "id": "settingBtnContainer",
                            "name": "settingBtnContainer",
                            "type": "Container",
                            "x": 40,
                            "y": 954,
                            "visible": false,
                            "layout": true,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "btn_setting_highlighted",
                                    "name": "btn_setting_highlighted",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": false,

                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'setting_pressed.png',
                                        out: 'setting_pressed.png',
                                        down: 'setting_pressed.png',
                                        disable: 'setting_pressed.png',
                                        enable: 'setting_pressed.png',
                                        hover: 'setting_pressed.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                                {
                                    "id": "btn_setting",
                                    "name": "btn_setting",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'setting_up.png',
                                        out: 'setting_up.png',
                                        down: 'setting_up.png',
                                        disable: 'setting_disable.png',
                                        enable: 'setting_up.png',
                                        hover: 'setting_over.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                            ]
                        },

                        {
                            "id": "gameRulesBtnContainer",
                            "name": "gameRulesBtnContainer",
                            "type": "Container",
                            "x": 40,
                            "y": 954,
                            "visible": false,
                            "layout": true,
                            "filterTypes": [],
                            child: [
                                {
                                    "id": "btn_game_highlighted",
                                    "name": "btn_game_highlighted",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": false,
                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'game_rules_pressed.png',
                                        out: 'game_rules_pressed.png',
                                        down: 'game_rules_pressed.png',
                                        disable: 'game_rules_pressed.png',
                                        enable: 'game_rules_pressed.png',
                                        hover: 'game_rules_pressed.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                                {
                                    "id": "btn_game_rules",
                                    "name": "btn_game_rules",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "x": 0,
                                    "y": 0,
                                    "height": 80,
                                    "width": 80,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'game_rules_up.png',
                                        out: 'game_rules_up.png',
                                        down: 'game_rules_up.png',
                                        disable: 'game_rules_disable.png',
                                        enable: 'game_rules_up.png',
                                        hover: 'game_rules_over.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {},

                                },
                            ]
                        },

                        {
                            "id": "Button_M7",
                            "name": "btn_menu_close",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1702,
                            "y": 221,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_menu.png',
                                out: 'land_menu.png',
                                down: 'land_menu.png',
                                disable: 'land_menu.png',
                                enable: 'land_menu.png',
                                hover: 'land_menu.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        {
                            "id": "btn_game_exit",
                            "name": "btn_game_exit",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "x": 40,
                            "y": 954,
                            "width": 80,
                            "height": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'exit_up.png',
                                out: 'exit_up.png',
                                down: 'exit_pressed.png',
                                disable: 'exit_disable.png',
                                enable: 'exit_up.png',
                                hover: 'exit_over.png'
                            },
                            "hitareaVisible": true,

                        },
                        {
                            "id": "btn_menu_close",
                            "name": "btn_menu_close",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": true,
                            "x": 26,
                            "y": 939,
                            "height": 110,
                            "width": 110,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'menu_down.png',
                                out: 'menu_down.png',
                                down: 'menu_down.png',
                                disable: 'menu_down.png',
                                enable: 'menu_down.png',
                                hover: 'menu_down.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,

                        },
                        {
                            "id": "btn_menu",
                            "name": "btn_menu",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": false,
                            "x": 26,
                            "y": 939,
                            "height": 110,
                            "width": 110,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'menu_up.png',
                                out: 'menu_up.png',
                                down: 'menu_up.png',
                                disable: 'menu_disable.png',
                                enable: 'menu_up.png',
                                hover: 'menu_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,

                        },
                        {
                            "name": "menuBack",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 1702,
                            "y": 220,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M7",
                            "name": "btn_menu",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1702,
                            "y": 221,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_menu.png',
                                out: 'land_menu.png',
                                down: 'land_menu.png',
                                disable: 'land_menu_disable.png',
                                enable: 'land_menu.png',
                                hover: 'land_menu.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },



                        {
                            "name": "paytableBack",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 51,
                            "y": 542,
                            "height": 126,
                            "width": 126,
                        },

                        {
                            "id": "Button_M1",
                            "name": "btn_paytable",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 84,
                            "y": 575,
                            "height": 63,
                            "width": 59,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'autoplay_setting_icon_up.png',
                                out: 'autoplay_setting_icon_up.png',
                                down: 'autoplay_setting_icon_up.png',
                                disable: 'land_paytable_disable_icon.png',
                                enable: 'autoplay_setting_icon_up.png',
                                hover: 'autoplay_setting_icon_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "Button_Paytable",
                            "name": "btn_paytable",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": true,
                            "x": 228,
                            "y": 963,
                            "height": 80,
                            "width": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'paytable_up.png',
                                out: 'paytable_up.png',
                                down: 'paytable_up.png',
                                disable: 'paytable_disable.png',
                                enable: 'paytable_up.png',
                                hover: 'paytable_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },




                        {
                            "id": "Button_7",
                            "name": "btn_autoplay_stopdesktop",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": false,
                            "layout": true,
                            "x": 1770,
                            "y": 900,
                            "height": 142,
                            "width": 142,
                            "text": "",
                            "visible": false,
                            "buttonState": {
                                up: 'autoplay_spin_up.png',
                                out: 'autoplay_spin_up.png',
                                down: 'autoplay_spin_up.png',
                                disable: 'autoplay_spin_up.png',
                                enable: 'autoplay_spin_up.png',
                                hover: 'autoplay_spin_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        /*     {
                                "id": "Button_21",
                                "name": "btn_spinStop",
                                "type": objectTypes.Sprite,
                                "buttonMode": true,
                                "uimode": "desktop",
                                "interactive": true,
                                "layout": false,
                                "x": 1770,
                                "y": 900,
                                "height": 142,
                                "width": 142,
                                "text": "",
                                "visible": true,
                                "buttonState": {
                                    up: 'stop_over.png',
                                    out: 'stop_over.png',
                                    down: 'stop_over.png',
                                    disable: 'stop_over.png',
                                    enable: 'stop_over.png',
                                    hover: 'stop_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            }, */

                        // {
                        //     "id": "Button_M21",
                        //     "name": "btn_spinStop",
                        //     "type": objectTypes.Sprite,
                        //     "buttonMode": true,
                        //     "layout": true,
                        //     "uimode": "mobile",
                        //     "interactive": false,
                        //     "x": 1770,
                        //     "y": 900,
                        //     "height": 142,
                        //     "width": 142,
                        //     "text": "",
                        //     "visible": false,
                        //     "buttonState": {
                        //         up: 'autoplay_spin_up.png',
                        //         out: 'autoplay_spin_up.png',
                        //         down: 'autoplay_spin_up.png',
                        //         disable: 'autoplay_spin_up.png',
                        //         enable: 'autoplay_spin_up.png',
                        //         hover: 'autoplay_spin_over.png'
                        //     },
                        //     "hitareaVisible": false,
                        //     "shapeVisible": false,
                        //     "shape": {}
                        // },

                        {
                            "id": "btn_autoplay",
                            "name": "btn_autoplay",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": true,
                            "x": 1684,
                            "y": 964,
                            "height": 80,
                            "width": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'autoplay_up.png',
                                out: 'autoplay_up.png',
                                down: 'autoplay_up.png',
                                disable: 'autoplay_disable.png',
                                enable: 'autoplay_up.png',
                                hover: 'autoplay_over.png'
                            },

                        },


                        {
                            "name": "stakeBack",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 1702,
                            "y": 621,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M9",
                            "name": "btn_stake",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 1702,
                            "y": 621,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_stake_icon.png',
                                out: 'land_stake_icon.png',
                                down: 'land_stake_icon.png',
                                disable: 'land_stake_disable_icon.png',
                                enable: 'land_stake_icon.png',
                                hover: 'land_stake_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },



                        {
                            "id": "btn_stake",
                            "name": "btn_stake",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": true,
                            "x": 1594,
                            "y": 964,
                            "height": 80,
                            "width": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'stake_up.png',
                                out: 'stake_up.png',
                                down: 'stake_up.png',
                                disable: 'stake_disable.png',
                                enable: 'stake_up.png',
                                hover: 'stake_over.png'
                            },


                        },

                        {
                            "id": "Button_5",
                            "name": "btn_sound",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": false,
                            "x": 138,
                            "y": 964,
                            "height": 80,
                            "width": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'sound_over.png',
                                out: 'sound_up.png',
                                down: 'sound_over.png',
                                disable: 'sound_disable.png',
                                enable: 'sound_up.png',
                                hover: 'sound_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },




                        {
                            "name": "soundBack",
                            "image": "land_base_btn.png",
                            "type": objectTypes.Sprite,
                            "layout": true,
                            "uimode": "mobile",
                            "visible": true,
                            "x": 51,
                            "y": 369,
                            "height": 126,
                            "width": 126,
                        },
                        {
                            "id": "Button_M6",
                            "name": "btn_sound",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 51,
                            "y": 370,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": true,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_sound_on_icon.png',
                                out: 'land_sound_on_icon.png',
                                down: 'land_sound_on_icon.png',
                                disable: 'land_sound_on_icon.png',
                                enable: 'land_sound_on_icon.png',
                                hover: 'land_sound_on_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },
                        {
                            "id": "Button_M7",
                            "name": "btn_soundOff",
                            "type": objectTypes.Sprite,
                            "interactive": true,
                            "layout": true,
                            "uimode": "mobile",
                            "x": 51,
                            "y": 370,
                            "height": 126,
                            "width": 126,
                            "text": "",
                            "visible": false,
                            "buttonMode": true,
                            "buttonState": {
                                up: 'land_sound_off_icon.png',
                                out: 'land_sound_off_icon.png',
                                down: 'land_sound_off_icon.png',
                                disable: 'land_sound_off_icon.png',
                                enable: 'land_sound_off_icon.png',
                                hover: 'land_sound_off_icon.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },


                        {
                            "id": "Button_12",
                            "name": "btn_soundOff",
                            "type": objectTypes.Sprite,
                            "buttonMode": true,
                            "uimode": "desktop",
                            "interactive": true,
                            "layout": true,
                            "x": 138,
                            "y": 964,
                            "height": 80,
                            "width": 80,
                            "text": "",
                            "visible": true,
                            "buttonState": {
                                up: 'mute_over.png',
                                out: 'mute_up.png',
                                down: 'mute_over.png',
                                disable: 'mute_disable.png',
                                enable: 'mute_up.png',
                                hover: 'mute_over.png'
                            },
                            "hitareaVisible": false,
                            "shapeVisible": false,
                            "shape": {}
                        },

                        {
                            "id": "text_24",
                            "name": "Text_COUNT_APdesktop",
                            "type": "Text",
                            "uimode": "desktop",
                            "layout": false,
                            "x": 1840,
                            "y": 970,
                            "text": "",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            width: 100,
                            "scaleToFit": true,
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 36,
                                fontWeight: 'bold',
                                fill: ['#000000'],
                                align: "center",

                            },
                            "parentLayer": "specialAnimationLayer",
                        },


                        {
                            "id": "text_24",
                            "name": "Text_COUNT_APmobile",
                            "type": "Text",
                            "uimode": "mobile",
                            "layout": true,
                            "x": 1777,
                            "y": 489,
                            "text": "",
                            "anchor": [0.5, 0.5],
                            "visible": true,
                            width: 100,
                            "scaleToFit": true,
                            "textStyle": {
                                fontFamily: 'Arial',
                                fontSize: 36,
                                fontWeight: 'bold',
                                fill: ['#000000'],
                                align: "center",

                            },
                            "parentLayer": "specialAnimationLayer",
                        },

                        {
                            "id": "betPanelContainer",
                            "name": "betPanelContainer",
                            "type": "Container",
                            "x": 688,
                            "y": 910,
                            "visible": false,
                            "layout": true,
                            "filterTypes": [],
                            child: [
                                {
                                    "name": "stake_bg",
                                    "image": "stake_bg.png",
                                    "type": objectTypes.Sprite,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "visible": true,
                                    "width": 548,
                                    "height": 95,
                                    "x": 0,
                                    "y": 0,
                                },

                                {
                                    "id": "btn_maxbet",
                                    "name": "btn_maxbet",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "layout": true,
                                    "interactive": true,
                                    "x": 454,
                                    "y": 17,
                                    "height": 60,
                                    "width": 60,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'max_up.png',
                                        out: 'max_up.png',
                                        down: 'max_up.png',
                                        disable: 'max_disable.png',
                                        enable: 'max_up.png',
                                        hover: 'max_over.png'
                                    },

                                },
                                {
                                    "id": "btn_minbet",
                                    "name": "btn_minbet",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "layout": true,
                                    "x": 35,
                                    "y": 17,
                                    "height": 60,
                                    "width": 60,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'min_up.png',
                                        out: 'min_up.png',
                                        down: 'min_up.png',
                                        disable: 'min_disable.png',
                                        enable: 'min_up.png',
                                        hover: 'min_over.png'
                                    },

                                },
                                {
                                    "id": "Button_3",
                                    "name": "btn_bet_increase",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "layout": true,
                                    "x": 355,
                                    "y": 27,
                                    "height": 40,
                                    "width": 40,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'plus_up.png',
                                        out: 'plus_up.png',
                                        down: 'plus_up.png',
                                        disable: 'plus_disable.png',
                                        enable: 'plus_up.png',
                                        hover: 'plus_over.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {}
                                },
                                {
                                    "id": "Button_4",
                                    "name": "btn_bet_decrease",
                                    "type": objectTypes.Sprite,
                                    "buttonMode": true,
                                    "uimode": "desktop",
                                    "interactive": true,
                                    "layout": true,
                                    "x": 150,
                                    "y": 27,
                                    "height": 40,
                                    "width": 40,
                                    "text": "",
                                    "visible": true,
                                    "buttonState": {
                                        up: 'minus_up.png',
                                        out: 'minus_up.png',
                                        down: 'minus_up.png',
                                        disable: 'minus_disable.png',
                                        enable: 'minus_up.png',
                                        hover: 'minus_over.png'
                                    },
                                    "hitareaVisible": false,
                                    "shapeVisible": false,
                                    "shape": {}
                                },
                                {
                                    "name": "stake_icon",
                                    "image": "stake_icon.png",
                                    "type": objectTypes.Sprite,
                                    "layout": false,
                                    "uimode": "desktop",
                                    "visible": true,
                                    "width": 21,
                                    "height": 18,
                                    "x": 235,
                                    "y": 20,
                                },
                                {
                                    "id": "label_BetPanel",
                                    "name": "label_BetPanel",
                                    "type": "Text",
                                    "x": 297,
                                    "y": 28,
                                    "width": 200,
                                    "visible": true,
                                    "text": "stakeOptions_bet",
                                    "scaleToFit": true,
                                    "anchor": [0.5, 0.5],
                                    "textStyle": {
                                        font: '20px Oswald SemiBold',

                                        fill: ['#999999'],
                                    },
                                },

                            ]
                        },


                    ]
                }
            ]

        },

        {

            "id": "max_popup",
            "name": "max_popup",
            "type": "Container",
            "class": "",
            "x": 650,
            "y": 300,
            "filterTypes": [],
            "uimode": "desktop",
            "visible": false,
            "parentLayer": "specialAnimationLayer",
            child: [
                {
                    "name": "popupbackground_desktop",
                    "image": "popupbackground",
                    "type": "Image",


                    "visible": true,
                    "width": 635,
                    "height": 354,
                    "x": 0,
                    "y": 0,
                },
                {
                    "id": "popupbackground_text",
                    "name": "popupbackground_text",
                    "type": "Text",
                    "x": 310,
                    "y": 130,
                    "width": 600,
                    "visible": true,
                    "text": "game_fs-capped",
                    "scaleToFit": true,
                    "anchor": [0.5, 0.5],
                    "textStyle": {
                        fontFamily: 'Oswald-regular',
                        fontSize: 25,

                        fontStyle: 'normal',
                        fill: ['#ffff'],
                    },
                    "parentLayer": "specialAnimationLayer",
                },

                {
                    "id": "popupbackgroundbtn",
                    "name": "popupbackgroundbtn",
                    "type": "Image",
                    "buttonMode": true,


                    "interactive": true,
                    "x": 310,
                    "y": 250,
                    "height": 56,
                    "width": 150,
                    "text": "ui-popup_okay",
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "textStyle": {
                        fontFamily: 'Oswald-regular',
                        fontSize: 30,

                        fill: ['#ffff'],
                        align: "center",

                    },
                    "buttonState": {
                        up: 'popupbackgroundbtn',
                        out: 'popupbackgroundbtn',
                        down: 'popupbackgroundbtn',
                        disable: 'popupbackgroundbtn',
                        enable: 'popupbackgroundbtn',
                        hover: 'popupbackgroundbtn'
                    },
                    "hitareaVisible": true,

                },


            ]
        },
        {

            "id": "max_popup",
            "name": "max_popup",
            "type": "Container",
            "class": "",
            "x": 0,
            "y": 0,
            "filterTypes": [],
            "uimode": "mobile",
            "layout": true,
            "visible": false,
            "parentLayer": "specialAnimationLayer",
            child: [
                {
                    "name": "popupbackground_desktop",
                    "image": "popupbackground",
                    "type": "Image",


                    "visible": true,
                    "width": 635,
                    "height": 354,
                    "x": 0,
                    "y": 0,
                },
                {
                    "id": "popupbackground_text",
                    "name": "popupbackground_text",
                    "type": "Text",
                    "x": 310,
                    "y": 130,
                    "width": 600,
                    "visible": true,
                    "text": "game_fs-capped",
                    "scaleToFit": true,
                    "anchor": [0.5, 0.5],
                    "textStyle": {
                        fontFamily: 'Oswald-regular',
                        fontSize: 25,

                        fontStyle: 'normal',
                        fill: ['#ffff'],
                    },
                    "parentLayer": "specialAnimationLayer",
                },

                {
                    "id": "popupbackgroundbtn",
                    "name": "popupbackgroundbtn",
                    "type": "Image",
                    //"buttonMode": true,


                    "interactive": true,
                    "x": 310,
                    "y": 250,
                    "height": 56,
                    "width": 150,
                    "text": "ui-popup_okay",
                    "visible": true,
                    "anchor": [0.5, 0.5],
                    "textStyle": {
                        fontFamily: 'Oswald-regular',
                        fontSize: 30,

                        fill: ['#ffff'],
                        align: "center",

                    },
                    "buttonState": {
                        up: 'popupbackgroundbtn',
                        out: 'popupbackgroundbtn',
                        down: 'popupbackgroundbtn',
                        disable: 'popupbackgroundbtn',
                        enable: 'popupbackgroundbtn',
                        hover: 'popupbackgroundbtn'
                    },
                    "hitareaVisible": true,

                },


            ]
        }

    ],
}